var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "shadow-scroll-container",
      class: {
        active: !_vm.disabled,
        scrolled: _vm.hasScroll,
      },
    },
    [
      _c("div", {
        ref: "top",
        staticClass: "shadow-top",
        class: {
          active: !_vm.disabled && _vm.topShadowActive,
        },
      }),
      _c(
        "div",
        {
          ref: "container",
          staticClass: "scroll-container",
          attrs: { id: `scroll-container-${_vm._uid}` },
          on: { scroll: _vm.update },
        },
        [
          _c(
            "div",
            { staticClass: "scroll-container__content" },
            [_vm._t("default")],
            2
          ),
        ]
      ),
      _c("div", {
        ref: "bottom",
        staticClass: "shadow-bottom",
        class: {
          active: !_vm.disabled && _vm.bottomShadowActive,
        },
      }),
      _vm.withTopScroller
        ? _c(
            "div",
            { staticClass: "shadow-scroll-container__top" },
            [
              _c("top-button", {
                staticClass: "top-button",
                attrs: {
                  id: `top-button-${_vm._uid}`,
                  root: `#scroll-container-${_vm._uid}`,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }